/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_NowInputs */

const en_admin_dashboard_now = /** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

const de_admin_dashboard_now = /** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt`)
};

const es_admin_dashboard_now = /** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora`)
};

const fr_admin_dashboard_now = /** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenant`)
};

const pt_br2_admin_dashboard_now = /** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora`)
};

const ro_admin_dashboard_now = /** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acum`)
};

/** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */
const it_admin_dashboard_now = en_admin_dashboard_now;

/** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */
const pl_admin_dashboard_now = en_admin_dashboard_now;

/** @type {(inputs: Admin_Dashboard_NowInputs) => LocalizedString} */
const hu_admin_dashboard_now = en_admin_dashboard_now;

/**
* | output |
* | --- |
* | "Now" |
*
* @param {Admin_Dashboard_NowInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_now = /** @type {((inputs?: Admin_Dashboard_NowInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_NowInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_now(inputs)
	if (locale === "de") return de_admin_dashboard_now(inputs)
	if (locale === "es") return es_admin_dashboard_now(inputs)
	if (locale === "fr") return fr_admin_dashboard_now(inputs)
	if (locale === "it") return it_admin_dashboard_now(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_now(inputs)
	if (locale === "pl") return pl_admin_dashboard_now(inputs)
	if (locale === "hu") return hu_admin_dashboard_now(inputs)
	return ro_admin_dashboard_now(inputs)
});
export { admin_dashboard_now as "admin.dashboard.now" }